const n = "container", t = {
  container: n,
  "container--full-width": "container--full-width",
  "container--colored": "container--colored",
  "container--theme-aware": "container--theme-aware",
  "container--aware-gradient-top-left": "container--aware-gradient-top-left",
  "container--aware-gradient-bottom-right": "container--aware-gradient-bottom-right",
  "container--neutral-gradient-top-left": "container--neutral-gradient-top-left",
  "container--blue-gradient-top-left": "container--blue-gradient-top-left",
  "container--blue-gradient-bottom-right": "container--blue-gradient-bottom-right",
  "container--neutral-gradient-bottom-right": "container--neutral-gradient-bottom-right",
  "container--neutral-gradient-neutral-100-neutral-400": "container--neutral-gradient-neutral-100-neutral-400",
  "container--neutral-100": "container--neutral-100",
  "container--neutral-200": "container--neutral-200",
  "container--grey-50": "container--grey-50",
  "container--grey-100": "container--grey-100",
  "container--grey-300": "container--grey-300",
  "container--white": "container--white",
  "container--split-gradient-radial": "container--split-gradient-radial",
  "container__gradient-helper": "container__gradient-helper",
  "container--split-gradient-linear": "container--split-gradient-linear",
  "container--brand-gradient": "container--brand-gradient",
  "brand-gradient-animation": "brand-gradient-animation",
  "container--extended-background": "container--extended-background",
  "container--extended-background-bottom": "container--extended-background-bottom",
  "container--full-height": "container--full-height"
};
export {
  n as container,
  t as default
};
